import styled from 'styled-components';
import { spacing, colors, zIndex } from 'ui/theme';
import { DateRangePicker } from './DateRangePicker';

export const CollapisbleCalendarDateRangePicker = styled(DateRangePicker)`
  display: inline-block;
  padding: 0 ${spacing.quarter} 0 0;
  background: ${colors.white};
  z-index: ${zIndex.newDropdown};
  border-radius: ${spacing.quarter};
  color: ${colors.white};
`;
